<template>
  <v-app class='dense' :dark="darkTheme">
    <router-view></router-view>
    <notifications group="success" position="bottom left" />
    <notifications group="error" position="bottom left" />
  </v-app>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: 'App',
    computed: {
      ...mapGetters(['darkTheme'])
    },
  }
</script>
